var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCredentialTemplate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    fill: "#F9F9F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 16.5446C20 15.1393 21.1287 14 22.521 14H67.8985C69.2908 14 70.4194 15.1393 70.4194 16.5446V72.5268C70.4194 73.9322 69.2908 75.0714 67.8985 75.0714H22.521C21.1287 75.0714 20 73.9322 20 72.5268V16.5446ZM25.0419 19.0893V69.9821H65.3775V19.0893H25.0419Z",
    fill: "black",
    stroke: "#F9F9F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6519 16.6038C30.6519 15.1658 31.7646 14 33.1373 14H57.992C59.3647 14 60.4774 15.1658 60.4774 16.6038V27.0191C60.4774 28.4572 59.3647 29.6229 57.992 29.6229H33.1373C31.7646 29.6229 30.6519 28.4572 30.6519 27.0191V16.6038ZM35.6228 19.2076V24.4153H55.5065V19.2076H35.6228Z",
    fill: "black",
    stroke: "#F9F9F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8115 37.0795C27.8115 35.7068 29.0099 34.594 30.4882 34.594H59.9314C61.4097 34.594 62.608 35.7068 62.608 37.0795C62.608 38.4521 61.4097 39.5649 59.9314 39.5649H30.4882C29.0099 39.5649 27.8115 38.4521 27.8115 37.0795Z",
    fill: "black",
    stroke: "#F9F9F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5356 54.8326C50.5356 53.4599 51.6166 52.3472 52.9501 52.3472L60.1935 52.3472C61.5269 52.3472 62.6079 53.4599 62.6079 54.8326C62.6079 56.2053 61.5269 57.3181 60.1935 57.3181L52.9501 57.3181C51.6166 57.3181 50.5356 56.2053 50.5356 54.8326Z",
    fill: "black",
    stroke: "#F9F9F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5356 47.0211C50.5356 45.6484 51.6166 44.5356 52.9501 44.5356L60.1935 44.5356C61.5269 44.5356 62.6079 45.6484 62.6079 47.0211C62.6079 48.3938 61.5269 49.5066 60.1935 49.5066L52.9501 49.5066C51.6166 49.5066 50.5356 48.3938 50.5356 47.0211Z",
    fill: "black",
    stroke: "#F9F9F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5356 62.2891C50.5356 61.1125 51.6166 60.1587 52.9501 60.1587L60.1935 60.1587C61.5269 60.1587 62.6079 61.1125 62.6079 62.2891C62.6079 63.4657 61.5269 64.4195 60.1935 64.4195L52.9501 64.4195C51.6166 64.4195 50.5356 63.4657 50.5356 62.2891Z",
    fill: "black",
    stroke: "#F9F9F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8115 44.2518C27.8115 42.8399 28.9243 41.6953 30.297 41.6953H45.2098C46.5825 41.6953 47.6952 42.8399 47.6952 44.2518V64.7036C47.6952 66.1155 46.5825 67.2601 45.2098 67.2601H30.297C28.9243 67.2601 27.8115 66.1155 27.8115 64.7036V44.2518ZM32.7825 46.8083V62.1471H42.7243V46.8083H32.7825Z",
    fill: "#9CD241",
    stroke: "#F9F9F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCredentialTemplate);
export default __webpack_public_path__ + "static/media/credential-template.1ff7bb0f017961e8aa292c8c13295635.svg";
export { ForwardRef as ReactComponent };